import React from 'react';

interface YouTubePlayerProps {
  videoUrl: string;
  title?: string;
  className?: string;
}

// Convert YouTube URL to embed format
const getYouTubeEmbedUrl = (url: string): string => {
  // If already an embed URL, return as is
  if (url.includes('/embed/')) {
    return url;
  }

  // Extract video ID from various YouTube URL formats
  let videoId = '';

  // Handle youtu.be short links
  if (url.includes('youtu.be/')) {
    videoId = url.split('youtu.be/')[1].split('?')[0].split('&')[0];
  }
  // Handle youtube.com/watch?v= links
  else if (url.includes('youtube.com/watch')) {
    const urlParams = new URLSearchParams(url.split('?')[1]);
    videoId = urlParams.get('v') || '';
  }
  // Handle youtube.com/embed/ links
  else if (url.includes('youtube.com/embed/')) {
    videoId = url.split('/embed/')[1].split('?')[0];
  }

  // Return embed URL
  return videoId ? `https://www.youtube.com/embed/${videoId}` : url;
};

const YouTubePlayer: React.FC<YouTubePlayerProps> = ({ videoUrl, title, className }) => {
  const embedUrl = getYouTubeEmbedUrl(videoUrl);

  return (
    <div className={`relative w-full ${className}`} style={{ paddingBottom: '56.25%', height: 0 }}>
      <iframe
        src={embedUrl}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          border: 'none'
        }}
        allowFullScreen
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        title={title || 'YouTube video player'}
      />
    </div>
  );
};

export default YouTubePlayer;
